const degrees = [
  {
    school: 'Institute of Engineering & Management, Kolkata',
    degree: 'Bachelor of Technology in Computer Science & Engineering',
    link: 'https://iem.edu.in/',
    year: 2025,
    score: 'GPA: 9.4',
  },
  {
    school: 'Delhi Public School, Ruby Park, Kolkata',
    degree: 'Higher Secondary Education, AISSCE',
    link: 'https://www.dpskolkata.com/',
    year: 2021,
    score: '92%',
  },
  {
    school: 'South Point High School, Kolkata',
    degree: 'Secondary Education, AISSE',
    link: 'https://www.southpoint.edu.in/',
    year: 2019,
    score: '95%',
  },
];

export default degrees;
